import { render, staticRenderFns } from "./ActivityPageRow.vue?vue&type=template&id=9207dbfa&scoped=true&"
import script from "./ActivityPageRow.vue?vue&type=script&lang=js&"
export * from "./ActivityPageRow.vue?vue&type=script&lang=js&"
import style0 from "./ActivityPageRow.vue?vue&type=style&index=0&id=9207dbfa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9207dbfa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})
